module.exports = __webpack_public_path__ + "media/images/emblems/Prilly-coat_of_arms-415e03ac0696414464e116d6752acf33.svg";